import React, { useState } from "react";
import HeroSection from "../components/HeroSection";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // success | error message

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("phone", formData.phone);
      form.append("email", formData.email);
      form.append("message", formData.message);

      const response = await fetch(
        "https://dsdspl.com/mp_funds/public/api/public/contact",
        {
          method: "POST",
          body: form,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: data.message || "Message sent successfully! We will get back to you soon.",
        });
        setFormData({ name: "", phone: "", email: "", message: "" }); // reset form
      } else {
        setStatus({
          type: "error",
          message: data.message || "Failed to send message. Please try again.",
        });
      }
    } catch (error) {
      console.error("[Contact error]:", error);
      setStatus({
        type: "error",
        message: "Something went wrong. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Hero banner */}
      <HeroSection />

      <div className="mx-auto max-w-6xl px-4 py-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-center mt-2 mb-8 text-green-600">
          Contact MP Funds Office
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="rounded-2xl overflow-hidden border bg-white p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Office Information</h2>
              
              {/* <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="bg-green-100 p-2 rounded-lg">
                    <span className="text-green-600 text-xl">📍</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-700">Main Office Address</div>
                    <div className="text-gray-600">
                      Member of Parliament Local Area Development Scheme Office<br />
                      District Collectorate Campus<br />
                      Balia, Uttar Pradesh - 277001
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <span className="text-blue-600 text-xl">📞</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-700">Contact Numbers</div>
                    <div className="text-gray-600">
                      <div>Office: 05498-222345</div>
                      <div>Helpline: 1800-XXX-XXXX</div>
                      <div>Mobile: +91 94544 12345</div>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="bg-red-100 p-2 rounded-lg">
                    <span className="text-red-600 text-xl">✉</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-700">Email Addresses</div>
                    <div className="text-gray-600">
                      <div>General Inquiries: mpfunds.balia@nic.in</div>
                      <div>Grievances: grievances.mpfunds@up.gov.in</div>
                      <div>Technical Support: support.mplads@up.gov.in</div>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="bg-yellow-100 p-2 rounded-lg">
                    <span className="text-yellow-600 text-xl">🕒</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-700">Office Hours</div>
                    <div className="text-gray-600">
                      <div>Monday to Friday: 10:00 AM - 5:00 PM</div>
                      <div>Saturday: 10:00 AM - 2:00 PM</div>
                      <div>Sunday: Closed</div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden border">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3563.5218039551914!2d84.14941407426268!3d25.808738476756075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3992b783ba8f7d21%3A0x240c7e6b2d80a8e6!2sCollectorate%20Campus%2C%20Ballia%2C%20Uttar%20Pradesh%20277001!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="MP Funds Office Location"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl border p-6 shadow-sm">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Share New Project Proposal Idea or Share Your Feedback</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Do you have a sports infrastructure project idea for Uttar Pradesh or Rajasthan? We invite you to submit your proposal or share feedback about any existing project. Your suggestions help us build better facilities for our community.
            </p>
            
            <form className="space-y-4" onSubmit={handleSubmit}>
              {status && (
                <div
                  className={`p-4 rounded-lg ${
                    status.type === "success"
                      ? "bg-green-50 text-green-700 border border-green-200"
                      : "bg-red-50 text-red-700 border border-red-200"
                  }`}
                >
                  <div className="font-medium">
                    {status.type === "success" ? "✓ " : "✗ "}
                    {status.message}
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Full Name *
                </label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition"
                  placeholder="Enter your full name"
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Mobile Number *
                </label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition"
                  placeholder="Enter 10-digit mobile number"
                  type="tel"
                  pattern="[0-9]{10}"
                  value={formData.phone}
                  onChange={(e) => handleChange("phone", e.target.value)}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address *
                </label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition"
                  placeholder="Enter your email address"
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Message / Query *
                </label>
                <textarea
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 min-h-[150px] focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition"
                  placeholder="Please describe your query or concern..."
                  value={formData.message}
                  onChange={(e) => handleChange("message", e.target.value)}
                  required
                />
                <div className="text-xs text-gray-500 mt-1">
                  Please mention your constituency/village name if related to project status.
                </div>
              </div>

              <button
                type="submit"
                className="w-full rounded-lg bg-green-600 text-white px-6 py-3 font-medium hover:bg-green-700 disabled:opacity-50 transition duration-200 flex items-center justify-center gap-2"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Sending...
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Additional Information Section */}
        <div className="mt-12 bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-8 border border-green-100">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">How to Reach Us</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-sm">
                <span className="text-2xl text-green-600">📋</span>
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">For Project Proposals</h3>
              <p className="text-gray-600 text-sm">
                Submit project proposals at the District Collectorate Office, Balia
              </p>
            </div>

            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-sm">
                <span className="text-2xl text-blue-600">📞</span>
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Complaint Helpline</h3>
              <p className="text-gray-600 text-sm">
                Call 1800-XXX-XXXX for complaints related to MP fund projects
              </p>
            </div>

            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-sm">
                <span className="text-2xl text-purple-600">💻</span>
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Online Portal</h3>
              <p className="text-gray-600 text-sm">
                Visit mplads.gov.in for official guidelines and circulars
              </p>
            </div>
          </div>
        </div>

        {/* Emergency Contact */}
        <div className="mt-8 bg-red-50 border border-red-100 rounded-xl p-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div>
              <h3 className="font-bold text-gray-800 text-lg">Emergency Contact</h3>
              <p className="text-gray-600 text-sm mt-1">
                For urgent matters related to ongoing projects
              </p>
            </div>
            <div className="mt-4 md:mt-0">
              <div className="flex items-center gap-2">
                <span className="text-red-600">📱</span>
                {/* <span className="font-bold text-lg">+91 94544 12345</span> */}
              </div>
              <div className="text-sm text-gray-500 mt-1 text-center md:text-right">
                Available: 8 AM - 8 PM
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;